import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    taskId: String
  }

  toggle(event) {
    const checkbox = event.target

    if (checkbox.checked) {
      // Submit task for review via ClientTasksController#create
      const url = '/tasks/client-tasks'
      const formData = new FormData()
      formData.append('id', this.taskIdValue)

      fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: formData
      }).then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html)
        })
    }
  }
}
